<template>
  <div class="flex items-center gap-2">
    <button
      class="btn btn-xs btn-primary"
      @click="handleShowDetail"
    >
      Détails
    </button>
  </div>
</template>

<script setup lang="ts">
import { inject } from 'vue'

interface Props {
  data?: any
  params?: any
}

const props = defineProps<Props>()

const onShowDetail = inject<(arbitration: any) => void>('onShowArbitrationDetail')

const handleShowDetail = () => {
  const arbitrationData = props.data || props.params?.data
  onShowDetail?.(arbitrationData)
}
</script>
